var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 0.208851V4.80942H12.274C11.2794 4.80942 10.6076 5.01827 10.2605 5.43695C9.91348 5.85563 9.73945 6.48218 9.73945 7.31954V10.6133H14.826L14.1493 15.7721H9.73945V29H4.42738V15.7721H0V10.6133H4.42738V6.814C4.42738 4.65327 5.03014 2.97661 6.23274 1.78597C7.43535 0.595322 9.03947 0 11.0412 0C12.7426 0 14.0618 0.0692916 14.999 0.208851H15Z","fill":"currentColor"}));
}

Facebook.defaultProps = {"width":"15","height":"29","viewBox":"0 0 15 29","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
